import React from "react";
import { Badge, ListGroup } from "react-bootstrap";
import { PlantillaCorreoMasivoResumida } from "../../../services/correosMasivosServicios";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import IconContainer from "../../organisms/IconContainer";
import { RespuestaLeerPropietarios } from "../../../services/propietariosServicios";

export const ListaPlantillas = ({
  plantillas,
  onPlantillaClick,
}: {
  plantillas: PlantillaCorreoMasivoResumida[];
  onPlantillaClick: (plantilla: PlantillaCorreoMasivoResumida) => void;
}) => {
  return (
    <ListGroup as="ul">
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
      >
        <div className="ms-2 me-auto">
          <div>
            <h5>Plantillas</h5>
          </div>
        </div>
      </ListGroup.Item>
      {plantillas.map((p) => (
        <ListGroup.Item
          as="li"
          key={p.id}
          className="d-flex justify-content-between align-items-start"
          style={{ cursor: "pointer" }}
          onClick={() => {
            onPlantillaClick(p);
          }}
        >
          <div className="ms-2 me-auto">
            <div className="fw-bold">{p.asunto}</div>
            {p.grupoPropietarios && (
              <>
                <span className="text-primary">Para:</span>{" "}
                <i>{p.grupoPropietarios.nombre}</i>
              </>
            )}
            {(p.propietariosIndividuales.length > 0) && (
              <>
                <span className="text-primary">Para:</span>{" "}
                <i>
                  {obtenerNombresPropietariosIndividuales(
                    p.propietariosIndividuales
                  )}
                </i>
              </>
            )}
          </div>
          {!!p.programacion && (
            <Badge bg="white">
              <IconContainer>
                <AccessTimeIcon className="text-success" />
              </IconContainer>
            </Badge>
          )}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

const obtenerNombresPropietariosIndividuales = (
  propietariosIndividuales: RespuestaLeerPropietarios[]
): string => {
  if (propietariosIndividuales.length === 0) {
    return "";
  }
  const primerPropNombres = propietariosIndividuales[0].nombres;
  if (propietariosIndividuales.length === 1) {
    return primerPropNombres;
  }
  return primerPropNombres + ",...";
};
